<template>
  <div>
    <div :class="stepClass">
      <div class="columns is-multiline">
        <div class="column is-half-desktop is-full-tablet">
          <custom-input
            id="internationalCode"
            v-model.lazy="internationalCode.code"
            stop-clearfix
            :input-class="`input ${hasErrorClass($v.value.phoneNumber)}`"
            :label-as-a-container="false"
            :label="$t('common.international_code')"
            :error-text="errorGenerator($v.internationalCode)"
            @input="delayTouch(internationalCode.code)"
          >
            <multiselect
              v-model="internationalCode"
              :options="phoneCodeList"
              :multiple="false"
              :placeholder="$t('common.select_country')"
              :close-on-select="true"
              track-by="code"
              label="name"
              :allow-empty="false"
              :show-labels="false"
              :searchable="true"
            />
          </custom-input>
        </div>

        <div class="column is-half-desktop is-full-tablet">
          <input-custom
            id="single-phone"
            key="singlePhone"
            v-model.lazy="singlePhone"
            stop-clearfix
            :input-class="`input ${hasErrorClass($v.singlePhone)}`"
            type="text"
            :label="$t('business_listing.stepper.phone_number')"
            :error-text="errorGenerator($v.singlePhone)"
            info-text=""
            :placeholder="$t('common.single_phone')"
            @input="delayTouch($v.singlePhone)"
          />
        </div>

        <input-custom
          v-show="false"
          id="phone-number"
          key="phoneNumber"
          v-model.lazy="$v.value.phoneNumber.$model"
          stop-clearfix
          :input-class="`input ${hasErrorClass($v.value.phoneNumber)}`"
          type="text"
          :label="$t('business_listing.stepper.phone_number')"
          :error-text="errorGenerator($v.value.phoneNumber)"
          :info-text="$t('common.phone_example')"
          :placeholder="$t('common.phone_example')"
          @input="delayTouch($v.value.phoneNumber)"
        />

        <div class="column is-full">
          <input-custom
            id="email"
            key="email"
            v-model.lazy="$v.value.email.$model"
            stop-clearfix
            :input-class="`input ${hasErrorClass($v.value.email)}`"
            type="text"
            :label="$t('business_listing.stepper.email')"
            :error-text="errorGenerator($v.value.email)"
            @input="delayTouch($v.value.email)"
          />
        </div>
        <!-- <div class="column is-full">
          <input-custom
            id="web-url"
            key="webUrl"
            v-model.lazy="$v.value.webUrl.$model"
            stop-clearfix
            :input-class="`input ${hasErrorClass($v.value.webUrl)}`"
            type="text"
            :label="$t('business_listing.stepper.url')"
            :error-text="errorGenerator($v.value.webUrl)"
            @input="delayTouch($v.value.webUrl)"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { optionalEmail, checkInternationalCode, optionalUrl, validPhoneGoogleLib, singlePhoneGoogleLib } from '@/helpers/custom-validators.js'
import CustomInput from '@/components/Shared/CustomInput'
import InputCustom from '@/components/Shared/Form/InputCustom'
import formHelperMixin from '@/mixins/form-helper'
import extraConstants from '@/helpers/form-validators.js'
import Multiselect from 'vue-multiselect'

export default {

  name: 'StepContact',
  components: {
    CustomInput,
    InputCustom,
    Multiselect
  },
  mixins: [formHelperMixin],
  props: {
    stepClass: {
      type: String,
      default: ''
    },

    loading: {
      type: Boolean,
      default: false
    },

    isOuterStep: {
      type: Object,
      default: () => ({ first: true, last: false })
    },

    value: {
      type: Object,
      default: () => ({
        phoneNumber: '',
        email: '',
        webUrl: ''
      })
    },

    parsePhone: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      phoneCodeList: [],
      internationalCode: {
        name: '',
        code: ''
      },
      singlePhone: ''
    }
  },

  validations () {
    if (this.singlePhone.length > 0) {
      return {
        value: {
          phoneNumber: {
            validPhoneGoogleLib: validPhoneGoogleLib(this.internationalCode)
          },
          email: {
            optionalEmail: optionalEmail
          },
          webUrl: {
            optionalUrl: optionalUrl
          }
        },

        internationalCode: {
          validCode: checkInternationalCode
        },

        singlePhone: {
          singlePhone: singlePhoneGoogleLib(this.internationalCode)
        }
      }
    } else {
      return {
        value: {
          phoneNumber: {
            validPhoneGoogleLib: validPhoneGoogleLib(this.internationalCode)
          },
          email: {
            optionalEmail: optionalEmail
          },
          webUrl: {
            optionalUrl: optionalUrl
          }
        },
        internationalCode: {
          validCode: checkInternationalCode
        },
        singlePhone: {
          singlePhone: singlePhoneGoogleLib(this.internationalCode)
        }
      }
    }
  },
  watch: {
    $v: {
      handler (obj) {
        if (this.$v.value.phoneNumber.$anyError === true) {
          this.value.hasError = true
        } else if (this.$v.value.email.$anyError === true) {
          this.value.hasError = true
        } else if (this.$v.value.webUrl.$anyError === true) {
          this.value.hasError = true
        } else {
          this.value.hasError = false
        }
      },
      deep: true
    },

    value: {
      handler (obj) {
        if (this.value.phoneNumber.length > 0) {
          const pos = this.value.phoneNumber.indexOf('.')
          const code = this.value.phoneNumber.substr(1, pos - 1)
          if (code.length > 0) {
            this.internationalCode = this.phoneCodeList.find(v => v.code === code)
          } else {
            this.internationalCode = { name: '', code: '' }
          }
          this.singlePhone = this.value.phoneNumber.substr(pos + 1)
        }
      },
      deep: true
    },

    singlePhone: {
      handler (obj) {
        if (this.singlePhone.length > 0) {
          this.value.phoneNumber = '+' + this.internationalCode.code + '.' + this.singlePhone
        } else {
          this.value.phoneNumber = ''
        }
        this.$v.value.phoneNumber.$touch()
        this.$v.internationalCode.$touch()
      }
    },

    internationalCode: {
      handler (obj) {
        if (this.singlePhone.length > 0) {
          this.value.phoneNumber = '+' + this.internationalCode.code + '.' + this.singlePhone
          this.$v.value.phoneNumber.$touch()
          this.$v.singlePhone.$touch()
        }
      }
    }
  },

  beforeMount () {
    this.parseCountryCodes()
  },

  methods: {

    step ({ target }) {
      if (target.id === 'next-btn') {
        this.$emit('next', this.$v)
      } else if (target.id === 'prev-btn') {
        this.$emit('prev')
      }
    },

    parseCountryCodes () {
      this.phoneCodeList = JSON.parse(JSON.stringify(extraConstants.COUNTRYPHONECODES))
      this.phoneCodeList.forEach(country => {
        country.name = this.$t(country.name) + ' (+' + country.code + ')'
      })
    }
  }

}
</script>
